import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IPublicClientApplication, PublicClientApplication, InteractionType, BrowserCacheLocation } from '@azure/msal-browser';
import { MsalGuard, MsalInterceptor, MsalBroadcastService, MsalInterceptorConfiguration, MsalModule, MsalService, MSAL_GUARD_CONFIG, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG, MsalGuardConfiguration, MsalRedirectComponent } from '@azure/msal-angular';
import { LoaderInterceptorService } from '@shared/components/loader/loader-interceptor.service';
import { HttpErrorInterceptor } from '@shared/interceptors/http-error.interceptor';
import { SharedDataService } from './shared/services/shared-data.service';
import { MaterialModule } from './material/material.module';
import { PageNotFoundModule } from './page-not-found/page-not-found.module';
import { UnauthorisedModule } from './unauthorised/unauthorised.module';
import { QuestionnairesModule } from './features/questionnaires/questionnaires.module';
import { ClientsModule } from './features/clients/clients.module';
import { AnswerSetModule } from './features/answer-set/answer-set.module';
import { MainModule } from './main/main.module';
import {
  GlobalHeaderModule,
  GlobalFooterModule,
  EnvironmentBannerModule,
  LoaderModule
} from './shared/shared.module';
import { AppRoutingModule } from './app-routing/app-routing.module';
import { AppComponent } from './app.component';
import { SectorPipe } from '@app/shared/pipes/sector.pipe';
import 'tinymce/icons/default'
import { environment } from '@environment/environment';

export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: environment.msal.clientId,
      authority: 'https://login.microsoftonline.com/organizations',
      redirectUri: '/',
      postLogoutRedirectUri: '/'
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
    },
  });
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();
  protectedResourceMap.set(environment.api, [`${environment.msal.api}/user.all`]);

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap
  };
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    loginFailedRoute: `unauthorised`
  };
}

@NgModule({
  declarations: [
    AppComponent,
    SectorPipe
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    PageNotFoundModule,
    UnauthorisedModule,
    MainModule,
    GlobalHeaderModule,
    GlobalFooterModule,
    QuestionnairesModule,
    ClientsModule,
    AnswerSetModule,
    HttpClientModule,
    MsalModule,
    LoaderModule,
    EnvironmentBannerModule,
    AppRoutingModule
  ],
  providers: [
    SharedDataService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptorService,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory
    },
    MsalService,
    MsalGuard,
    MsalBroadcastService
  ],
  bootstrap: [AppComponent, MsalRedirectComponent]
})
export class AppModule { }
